import * as React from "react";
import "./title.scss";

interface ITitleProps {
  readonly extraClasses?: string;
  readonly title: string;
  readonly small?: boolean;
  readonly isPrice?: boolean;
}

class Title extends React.Component<ITitleProps, {}> {
  public render() {
    const extraClasses = this.props.extraClasses || "";
    return (
      <div
        className={`title ${this.props.small ? "title--small" : ""} ${
          this.props.isPrice ? "title--pricing" : ""
        }`}
      >
        <h2 className={`${extraClasses}`}>{this.props.title}</h2>
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/title/title.tsx